<template>
  <div class="row">
    <div class="col-lg-12">
      <loader v-if="!isLoaded"></loader>

      <div class="row without_btn">
        <div class="col-12">
          <table-view
              :options="options"
              :isLoaded=isLoaded
              :isChange=isChange
              :isList=isMobile>

            <div slot="name" slot-scope="props">
                <div class="icon-circle" v-if="props.row.logo">
                  <img :src="props.row.logo" alt="">
                </div>
                <strong>{{props.row.name}}</strong>
            </div>

            <div slot="logo" slot-scope="props">
              <div class="icon-circle" v-if="props.row.logo">
                <img :src="props.row.logo" alt="">
              </div>
            </div>


            <div slot="action" slot-scope="props">
              <button class="btn btn-link" @click.prevent="onModalBtnClick(props.row)">
                <mdc-icon icon="edit"></mdc-icon>
              </button>

            </div>
          </table-view>
        </div>
      </div>

    </div>

    <clinical-modal v-if="isModalVisible"
                    :visible="isModalVisible"
                   :data="modal.data"
                   v-on:close="onModalClose">
    </clinical-modal>


  </div>
</template>

<script>

    import TableView from '../../../common/table/components/TableView';
    import lang from '../../../lang/translator';
    import {mapGetters} from 'vuex';
    import axios from 'axios';
    import Manager from '../api/Manager';
    import moment from 'moment';
    import Constants from '../../undesirableBehavior/Constants';
    import Loader from '../../loader/components/Loader';
    import clinicalModal from './ClinicalModal';
    import {Validator} from 'vee-validate';

    export default {
    name: 'ClinicalCenter',
    data() {
      return {
        apiUrl: '/users/centers',
        isModalVisible: false,
        client: {},
        isChange: false,
        disabled: false,
        onlyList: false,
        reloadBids: false,
        isLoaded: true,
        rangeDateStart: this.getDateStart(new Date()),
        rangeDateEnd: new Date(),
        price: "999 рублей",
        client_count: null,
        minDateStart: this.getMinDateStart(new Date()),
        regions: [],
        regionId: null,
        loading: false,
        lastId: null,
        isLastPage: false,
        comment: null,
        baseUrl: process.env.APP_URL,
        modal: {
          data: {},
        },
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
        options: {
          pageHeader: 'clinicalCenter',
          filterable: false,
          initialPage: null,
          debounce: 1000,
          sortable: [],
          skin: 'table table-sm',
          columns: [
            {
              key: 'name',
              changed: true,
              headings: lang.get('profile.name'),
            },
            {
              key: 'phone',
              changed: false,
              headings: lang.get('profile.phone'),
            },
            {
              key: 'address',
              changed: false,
              headings: lang.get('profile.address'),
            },
            {
              key: 'socialNetwork',
              changed: false,
              headings: lang.get('profile.other_contact'),
            },
            {
              key: 'action',
              changed: true,
              headings: '',
            },
          ],
          listRow: {
            name:{
              headings: lang.get('profile.name'),
              hasTemplate: false,
            },
            phone:{
              headings: lang.get('profile.phone'),
              hasTemplate: false,
            },
            address:{
              headings: lang.get('profile.address'),
              hasTemplate: false,
            },
            socialNetwork:{
              headings: lang.get('profile.other_contact'),
              hasTemplate: false,
            },
          },
          requestFunction: this.requestFunction,
          responseAdapter: function(resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total,
            };
          },
          texts: {
            filter: '',
            filterPlaceholder: lang.get(
                'user.type_the_therapist_name_to_search'),
            noResults: lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table'),
          },
          columnsClasses: {
            clientCount: 'text-center',
            cost: 'text-center',
            phone: 'nowrap',
            action: 'text-right actions-cell',
          },
          perPage: 10,
        },
      };
    },
    components: {
      TableView, Loader, clinicalModal
    },

    computed: {
      ...mapGetters('mobile', [
        'isMobile',
      ]),
    },
      created(){
        console.info(process)
      },

    methods: {
      onModalClose() {
        this.modal.data = {};
        this.isModalVisible = false;
        this.isChange = true;
      },

      onModalBtnClick(item) {
        this.modal.data = item;
        this.isModalVisible = true;
        this.isChange = false;
      },

      onSetSelected: function (selected) {
        this.therapistId = selected;
      },

      getOptionTitle: function ({option}) {
        return option.name;
      },
      isLast: function ({option}) {
        return option.id == this.lastId;
      },

      async requestFunction(data) {
        localStorage.setItem('currentPage', data.page);
        localStorage.setItem('currentPageHeader', 'clinicalCenter');
        let response = await Manager.getClinicalCenter(data.limit, data.page);
        console.info(process)
        return response;
      },

      getMinDateStart: function (date) {
        let minDateStart = new Date((date.getFullYear() - 1), date.getMonth(),
            date.getDate());
        return minDateStart;
      },

      getDateStart: function (date) {
        let minDateStart = new Date(date.getFullYear(), date.getMonth(),  date.getDate(), (date.getHours() - 1));
        return minDateStart;
      },

      rangeDateStartTimestamp() {
        return moment(this.rangeDateStart).startOf('day').unix() + (Math.abs(this.rangeDateStart.getTimezoneOffset()) * Constants.SECONDS_PER_MINUTE);
      },
      rangeDateEndTimestamp() {
        return moment(this.rangeDateEnd).endOf("day").unix() + (Math.abs(this.rangeDateEnd.getTimezoneOffset()) * Constants.SECONDS_PER_MINUTE);
      },

    },

  };
</script>



// WEBPACK FOOTER //
// src/modules/profile/components/ClinicalCenter.vue